
import React from 'react';
import { Modal } from 'react-bootstrap';

const ModalComponent = (props) => {
    return (
        <Modal {...props.data} onHide={props.handleCancel}>
            <Modal.Body>
                {props.children}
            </Modal.Body>
        </Modal>
    );
}
 
export default ModalComponent;
